import { render, staticRenderFns } from "./WeekDays.vue?vue&type=template&id=5e645fee"
import script from "./WeekDays.vue?vue&type=script&lang=js"
export * from "./WeekDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports